import { ErrorPage } from "../../ErrorPage";
import { routes } from "../../../routing/routes";

export function SettingsError() {
  return <ErrorPage buttonHref={routes.settings()} buttonText="Refresh page" />;
}
